/*

Ashraf 11/27/2022 2698947782 delete field confirmation form
Ashraf 12/03/2022 2698947782 changed color of buttons
Ravi 05/31/2023 2698947782 changed delete popup message
Sohel 09/26/2023 5155351299 Changed Delete Field Popup UI
*/

import React from 'react';
import {Button, Grid, Typography} from '@material-ui/core';
import inputStyles from '../../../../../components/InputStyles';

// delete field popup
export default function DeleteForm({deletedFieldIds,
  setDeletedFieldIds, initialValues, setDeleteData, deleteData, handleClose, handleDeleteSubmit, data, setOldFieldName,
  setFieldOperation}) {
  const classes = inputStyles();

  // deleting a field after submit
  const handleSubmit = () => {
    handleDeleteSubmit();
    handleClose();
  };
  return (
    <Grid container>
      <Grid xs={12} className="text-center new-standard-textfields">
        <Typography variant="h4" className="global-field-textfields">
          Are you sure you want to delete the {`${deleteData?.fieldLabel ? deleteData?.fieldLabel : ''}`} Field?
        </Typography>
        <div className="mt-3 mb-2">
          <Button variant="outlined" className={`mx-1 search-btn ${classes.buttonRoot}`} onClick={() => {
            handleClose();
            setDeleteData({});
          }} >
            <span>No</span>
          </Button>
          <Button variant="outlined" className={`ml-1 reset-btn ${classes.buttonRoot}`} onClick={handleSubmit}>
            <span>Yes</span>
          </Button>
        </div>
      </Grid>
    </Grid>
  );
}
